const dashboardRouter = {
    path: "/dashboard",
    name: "dashboard",
    meta: {
        title: "首页"
    },
    component: () => import("@/view/dashboard")
};

export default dashboardRouter;



// WEBPACK FOOTER //
// ./src/router/modules/dashboard.js